module.exports = __webpack_public_path__ + "img/logo-wandr_e-compact.f92b0134.svg";